// Module
var code = "<div id=\"test\"> Test component </div>";
// Exports
module.exports = code;